import React, { useEffect } from 'react';
import './Experiences.scss';
import Experience from '../Experience/Experience';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Experiences = ({ isDarkMode, onSkillsHover }) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const experiences = [
    {
      title: "Full-stack Developer",
      company: "T & Y Consulting (Freelance)",
      period: "2024 - Present",
      description: "Contributed to the development of a SaaS platform. Implemented new features and fixed bugs across both front-end and back-end. Comfortable handling full-stack projects and open to new freelance opportunities.",
      skills: ["Vue.js", "React.js", "Next.js", "Node.js", "Typescript", "Javascript", "SASS / SCSS", "HTML5", "CSS3", "GIT", "NPM", "RESTful APIs"]
    },
    {
      title: "Full-stack Developer",
      company: "Idomoo",
      period: "2022 - 2024",
      description: "Developed from scratch various web applications - UI library, payment API etc. Worked closely with UX designer to create intuitive user interfaces. Contributed to the development as part of a teamby implementing new features and fixing bugs. Gained experience in agile development methodologies.",
      skills: ["Vue.js", "Node.js", "Typescript", "Javascript", "GraphQL", "MongoDB", "SASS / SCSS", "HTML5", "CSS3", "GIT", "NPM", "RESTful APIs"]
    },
    {
      title: "Front-end Developer",
      company: "Elevate Digital Studio",
      period: "2020 - 2022",
      description: "Developing from scratch tailor-made websites. Implemented new features and fixed bugs. Worked closely with UX designers. Implemented responsive designs and optimized front-end performance.",
      skills: ["Vue.js", "Javascript", "jQuery", "SASS / SCSS", "HTML5", "CSS3", "RESTful APIs"]
    },
    {
      title: "Front-end Developer",
      company: "Yarden Amir Inc. (Freelance & Contract)",
      period: "2018 - 2020",
      description: "Worked on diverse freelance and contract projects, including building a WordPress site for a design studio, styling and layout adjustments for clients, and HTML development for ELAL. Gained hands-on experience in front-end development, working with real-world designs and collaborating with clients and teams.",
      skills: ["Javascript", "HTML5", "CSS3", "SASS / SCSS", "Wordpress"]
    }
  ];

  const handleExperienceHover = (skills) => {
    if (typeof onSkillsHover === 'function') {
      onSkillsHover(skills);
    }
  };

  return (
    <section id="experiences" className="experiences-section">
      <h2 className="section-title">Professional Experience</h2>
      <div className="experiences-container">
        {experiences.map((experience, index) => (
          <Experience
            key={index}
            title={experience.title}
            company={experience.company}
            period={experience.period}
            description={experience.description}
            skills={experience.skills}
            onHover={handleExperienceHover}
            isDarkMode={isDarkMode}
          />
        ))}
      </div>
    </section>
  );
};

export default Experiences; 